import ConfigurableForm from './ConfigurableForm';

export default ConfigurableForm;
